import React from 'react';
import PropTypes from 'prop-types';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import CookiesDisabledLogin from 'pages/login/CookiesDisabledLogin';
import LoginForm from 'pages/login/LoginForm';
import Notification from 'components/notifications/Notification';
import OutdatedBrowser from 'components/layout/OutdatedBrowser/OutdatedBrowser';
import compose from 'recompose/compose';
import injectSheet from 'react-jss';
import styled from 'styled-components';
import utils from 'helpers/utils';
import { authLogin } from 'store/actions/auth/authLogin';
import { connect } from 'react-redux';
import { fetchAndSetDefaultAccount } from 'services/auth';
import LoginBackground from 'components/layout/Layout/LoginBackground';

const StyledCard = styled(Card)`
    width: 300px;
    max-width: 300px;
`;

const StyledLogo = styled.div`
    margin-top: 20px;
    text-align: center;
`;

class LoginContainer extends React.Component {
    handleSubmitForm = (values) => {
        const {
            dispatchForm,
            history,
            path,
        } = this.props;

        return new Promise((resolve, reject) => {
            dispatchForm({
                onError: () => {
                    reject();
                },
                onSuccess: (response) => {
                    // Fetch a current account if available
                    fetchAndSetDefaultAccount(response).then(function () {
                        // Default path is '/';
                        resolve(history.push(path));
                    });
                },
                values: values,
            });
        });
    }

    render() {
        return (
            <div>
                <LoginBackground />

                { utils.isOutdatedBrowser() &&
                    <OutdatedBrowser />
                }

                <StyledCard>
                    <CardText>
                        <StyledLogo>
                            <img alt='mobian global' src={ `/images/logo_medium.png` } width={ 150 }/>
                        </StyledLogo>

                        {
                            utils.canUseCookies() ?
                                <LoginForm
                                    form='auth_sign_in'
                                    handleSubmitForm={ this.handleSubmitForm }
                                />
                                :
                                <CookiesDisabledLogin />
                        }
                    </CardText>
                </StyledCard>

                <Notification />
            </div>
        );
    }
}

LoginContainer.propTypes = {
    dispatchForm: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    path: PropTypes.string,
};

const mapStateToProps = (state, props) => {
    const { id } = props;

    return {
        data: state.bookings.data[id],
        path: state.path.path,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchForm: (values) => {
            dispatch(authLogin(values));
        },
    };
};

const enhance = compose(
    injectSheet(),
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
);

export default enhance(LoginContainer);



// WEBPACK FOOTER //
// ./src/pages/login/LoginContainer.js